/* BundleCard.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _58 = "._19pk1b66{margin-top:var(--ds-space-050,4px)}";
const _57 = "._k48p1fw0{font-weight:700}";
const _56 = "._18u0idpf{margin-left:0}";
const _55 = "._otyridpf{margin-bottom:0}";
const _54 = "._2hwxidpf{margin-right:0}";
const _53 = "._19pkidpf{margin-top:0}";
const _52 = "._vwz41j6v{line-height:1rem}";
const _51 = "._1dyzc64g{letter-spacing:.05rem}";
const _50 = "._syaz1fxt{color:var(--ds-text,#172b4d)}";
const _49 = "._1p1dangw{text-transform:uppercase}";
const _48 = "._k48p1nn1{font-weight:400}";
const _47 = "._1wyb1crf{font-size:9pt}";
const _46 = "._1iohnqa1:active{-webkit-text-decoration-style:solid;text-decoration-style:solid}";
const _45 = "._c2waglyw:active{-webkit-text-decoration-line:none;text-decoration-line:none}";
const _44 = "._1nrm18uv:active{-webkit-text-decoration-color:initial;text-decoration-color:initial}";
const _43 = "._1i0rf2e1:hover img{transform:translateX(10px) rotate(-2deg)}";
const _42 = "._1dbz1cd0:hover{box-shadow:var(--ds-shadow-overlay,0 8px 9pt #091e4226,0 0 1px #091e424f)}";
const _41 = "._jf4cnqa1:hover{-webkit-text-decoration-style:solid;text-decoration-style:solid}";
const _40 = "._1bnxglyw:hover{-webkit-text-decoration-line:none;text-decoration-line:none}";
const _39 = "._9oik18uv:hover{-webkit-text-decoration-color:initial;text-decoration-color:initial}";
const _38 = "._bfhk1bhr{background-color:var(--ds-surface-overlay,#fff)}";
const _37 = "._4t3i1pl1{height:29pc}";
const _36 = "._1ul9ncxg{min-width:264px}";
const _35 = "._p12f1edt{max-width:350px}";
const _34 = "._v5641jxq{transition:transform .3s ease,box-shadow .3s ease}";
const _33 = "._i0dlf1ug{flex-basis:0%}";
const _32 = "._1o9zkb7n{flex-shrink:1}";
const _31 = "._16jlkb7n{flex-grow:1}";
const _30 = "._ajmmnqa1{-webkit-text-decoration-style:solid;text-decoration-style:solid}";
const _29 = "._1hmsglyw{-webkit-text-decoration-line:none;text-decoration-line:none}";
const _28 = "._4bfu18uv{-webkit-text-decoration-color:initial;text-decoration-color:initial}";
const _27 = "._19itpp12{border:var(--_18x9sjc)}";
const _26 = "._2rkogktf{border-radius:20px}";
const _25 = "._8hrz11aj{transform-origin:top right}";
const _24 = "._t9ec1xcn{transform:translateX(10px)}";
const _23 = "._rsufyfq0{object-position:bottom}";
const _22 = "._5ral1f51{object-fit:contain}";
const _21 = "._4t3i1osq{height:100%}";
const _20 = "._1bsb1osq{width:100%}";
const _19 = "._v5641acn{transition:transform .4s ease-in-out}";
const _18 = "._bfhk18uv{background-color:initial}";
const _17 = "._4t3i1edt{height:350px}";
const _16 = "._19pk1wug{margin-top:auto}";
const _15 = "._4cvresu3{align-items:flex-end}";
const _14 = "._1bahesu3{justify-content:flex-end}";
const _13 = "._kqswh2mm{position:relative}";
const _12 = "._19bvidpf{padding-left:0}";
const _11 = "._u5f3idpf{padding-right:0}";
const _10 = "._ca0qidpf{padding-top:0}";
const _9 = "._18m915vq{overflow-y:hidden}";
const _8 = "._1reo15vq{overflow-x:hidden}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { Link } from 'react-router-dom';
import { H4 } from '../Typography';
import { BUNDLE_CARD_CATEGORY_TEST_ID, BUNDLE_CARD_IMAGE_TEST_ID, BUNDLE_CARD_TEST_ID, BUNDLE_CARD_TITLE_TEST_ID } from './constants';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _7 = "._ca0qxy5q{padding-top:var(--ds-space-400,2pc)}";
const _6 = "._19bvxy5q{padding-left:var(--ds-space-400,2pc)}";
const _5 = "._n3tdidpf{padding-bottom:0}";
const _4 = "._2lx21bp4{flex-direction:column}";
const _3 = "._1e0c1txw{display:flex}";
const _2 = "._zulpu2gc{gap:var(--ds-space-100,8px)}";
const _ = "._1yt41ejb{padding:var(--ds-space-300,24px)}";
const CardStyle = null;
const CategoryLabelStyle = null;
const CardContent = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5, _6, _7]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1yt41ejb _zulpu2gc _1e0c1txw _2lx21bp4 _n3tdidpf _19bvxy5q _ca0qxy5q", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  CardContent.displayName = 'CardContent';
}
const ImageContainer = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_8, _9, _10, _11, _5, _12, _13, _3, _14, _15, _16, _17, _18]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswh2mm _1e0c1txw _1bahesu3 _4cvresu3 _19pk1wug _4t3i1edt _bfhk18uv", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ImageContainer.displayName = 'ImageContainer';
}
const Image = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "img",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_19, _20, _21, _22, _23, _24, _25]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_v5641acn _1bsb1osq _4t3i1osq _5ral1f51 _rsufyfq0 _t9ec1xcn _8hrz11aj", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Image.displayName = 'Image';
}
const TitleStyle = null;
export const BundleCard = _ref4 => {
  let {
    title,
    category,
    image,
    navigationUrl,
    onClick
  } = _ref4;
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_26, _27, _8, _9, _28, _29, _30, _31, _32, _33, _34, _3, _4, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46]
    }), /*#__PURE__*/_jsxs(Link, {
      onClick: onClick,
      to: navigationUrl,
      "data-testid": BUNDLE_CARD_TEST_ID,
      className: ax(["_2rkogktf _19itpp12 _1reo15vq _18m915vq _4bfu18uv _1hmsglyw _ajmmnqa1 _16jlkb7n _1o9zkb7n _i0dlf1ug _v5641jxq _1e0c1txw _2lx21bp4 _p12f1edt _1ul9ncxg _4t3i1pl1 _bfhk1bhr _9oik18uv _1bnxglyw _jf4cnqa1 _1dbz1cd0 _1i0rf2e1 _1nrm18uv _c2waglyw _1iohnqa1"]),
      style: {
        "--_18x9sjc": ix("1px solid ".concat("var(--ds-border, #091E4224)"))
      },
      children: [/*#__PURE__*/_jsxs(CardContent, {
        children: [/*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_47, _48, _49, _50, _51, _52]
          }), /*#__PURE__*/_jsx("div", {
            "data-testid": BUNDLE_CARD_CATEGORY_TEST_ID,
            className: ax(["_1wyb1crf _k48p1nn1 _1p1dangw _syaz1fxt _1dyzc64g _vwz41j6v"]),
            children: category
          })]
        }), /*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_53, _54, _55, _56, _57, _58]
          }), /*#__PURE__*/_jsx(H4, {
            as: "h3",
            "data-testid": BUNDLE_CARD_TITLE_TEST_ID,
            className: ax(["_19pkidpf _2hwxidpf _otyridpf _18u0idpf _k48p1fw0 _19pk1b66"]),
            children: title
          })]
        })]
      }), /*#__PURE__*/_jsx(ImageContainer, {
        children: /*#__PURE__*/_jsx(Image, {
          src: image,
          alt: "".concat(title, " bundle"),
          "data-testid": BUNDLE_CARD_IMAGE_TEST_ID
        })
      })]
    })]
  });
};